module.exports = __webpack_public_path__ + "static/media/add-profile-circle.6a60421d.png";